// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__35vzC","header":"PatientBlock_header__1Gt5c","label":"PatientBlock_label__2NJ_M","option":"PatientBlock_option__28jE3"};